import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import Icon from '@/components/atoms/Icon.vue'
import HoverToolTip from '@/components/molecules/HoverToolTip.vue'

type PropsType = {
  eventType: string
  eventTypeText?: string
}

type EventsType = { [key: string]: { type: string; color: string } }


export default /*#__PURE__*/_defineComponent({
  __name: 'EventIcon',
  props: {
    eventType: null,
    eventTypeText: null
  },
  setup(__props: any) {

const props = __props as {
  eventType: string
  eventTypeText?: string
};



const events: EventsType = {
  illegalParking: {
    type: 'directions_car',
    color: 'color-white',
  },
  motion: {
    type: 'directions_run',
    color: 'color-white',
  },
  cameraMotion: {
    type: 'directions_run',
    color: 'color-event1',
  },
  heatmap: {
    type: 'whatshot',
    color: 'color-white',
  },
  liveCamera: {
    type: 'live_tv',
    color: 'color-white',
  },
  live: {
    type: 'live_tv',
    color: 'color-white',
  },
  audio: {
    type: 'volume_up',
    color: 'color-white',
  },
  peopleCounter: {
    type: 'people',
    color: 'color-white',
  },
  ptz: {
    type: 'control_camera',
    color: 'color-white',
  },
  enterAlert: {
    type: 'directions_run',
    color: 'color-white',
  },
  personTracking: {
    type: 'trending_up',
    color: 'color-white',
  },
  timeLapse: {
    type: 'timelapse',
    color: 'color-white',
  },
  operationAnalysis: {
    type: 'build',
    color: 'color-white',
  },
  dewarp: {
    type: '360',
    color: 'color-white',
  },
}

const type = computed<string>(() => {
  return events[props.eventType].type
})

const color = computed<string>(() => {
  return events[props.eventType].color
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(HoverToolTip, {
      "tool-tip-text": __props.eventTypeText,
      width: 140
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["event_icon", __props.eventType])
        }, [
          _createVNode(Icon, {
            type: _unref(type),
            color: _unref(color),
            size: "16"
          }, null, 8, ["type", "color"])
        ], 2)
      ]),
      _: 1
    }, 8, ["tool-tip-text"])
  ]))
}
}

})